import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import VideoFlyer from './VideoFlyer'
import styles from './flier.scss'

import { flyerSelector, eventTokenSelector } from 'src/selectors'
import { updateFlyerZoom } from 'src/actions/flyer'
import LoadingComponent from 'src/components/common/LoadingComponent/LoadingComponent'
import { VideoFlyerBackgrounds } from 'src/assets/frontend-json/video-flyer-backgrounds'

class Flier extends React.Component {
  componentDidMount() {
    this._hideTimer = setTimeout(this._unZoomFlyer, 7000)
  }

  componentWillUnmount() {
    this._cancelHideFlyerTimer()
  }

  _cancelHideFlyerTimer = () => {
    if (this._hideTimer) {
      clearTimeout(this._hideTimer)
    }
  }

  _unZoomFlyer = () => this.props.dispatch(updateFlyerZoom(false))

  _toggleZoom = () => this.props.dispatch(updateFlyerZoom(!this.props.flyerZoom))

  _renderLegacyFlyer(flier) {
    return (
      <img className={styles['flier']} src={flier.watermarked_url_2x} />
    )
  }

  _renderFlyer() {
    const { flyer, flier } = this.props.event

    if (flyer.type === 'VideoFlyer') {
      return <VideoFlyer
        className={styles['flier']}
        flyer={flyer}
        cancelHideFlyerTimer={this._cancelHideFlyerTimer}
        unZoomFlyer={this._unZoomFlyer}
      />
    } else {
      return this._renderLegacyFlyer(flier || flyer)
    }
  }

  render() {
    const { flyerZoom, event } = this.props
    const containerClassName = flyerZoom ? 'flier-container-zoom' : 'flier-container'

    const isLoading = event.flyer === null || (event.pending_flyer && event.pending_flyer.state === 'pending') || (event.flyer && event.flyer.state === 'pending') || event.state === 'activation_pending_flier'
    const flyer = event.pending_flyer || event.flyer
    const designNumber = flyer ? String(flyer.design_number) : null
    const isVideoFlyer = designNumber && Object.keys(VideoFlyerBackgrounds).includes(designNumber.toString())
    const imageBgSlug = isVideoFlyer ? VideoFlyerBackgrounds[designNumber] : null
    return (
      <div className={styles[containerClassName]} id='rsvp' onClick={this._toggleZoom}>

        {
          isLoading ? (
            <div className={styles['flyer-empty-container']}>
              <LoadingComponent
                type="partial"
                loading
                dark
                content="Loading..."
                containerStyle={{
                  maxHeight: '745px',
                  backgroundImage: imageBgSlug ? `url(/assets/Layouts/Backgrounds/${imageBgSlug}.jpg)` : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}
              />
            </div>
          ) : this._renderFlyer()
        }
      </div>
    )
  }
}

Flier.propTypes = {
  dispatch: PropTypes.func,
  event: PropTypes.object,
  flyerZoom: PropTypes.bool
}

function mapStateToProps(state) {
  return {
    flyerZoom: flyerSelector(state).flyerZoom,
    eventToken: eventTokenSelector(state)
  }
}

export default connect(mapStateToProps)(Flier)
